var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineWaiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76 1.2a.525.525 0 01.48 0l5.776 2.976c.174.09.284.27.284.467v5.6c0 .196-.11.376-.284.466L7.24 13.684a.525.525 0 01-.481 0L.985 10.71a.525.525 0 01-.285-.466v-5.6c0-.197.11-.377.285-.467L6.76 1.2zM1.75 5.48v4.442l4.725 2.435V7.77L1.75 5.481zm5.775 2.291v4.586l4.725-2.435V5.481L7.525 7.77zm4.076-3.143l-1.754.85L5.23 3.17 7 2.258l4.601 2.37zm-7.528-.862L2.4 4.628 7 6.86l1.655-.802-4.582-2.291z",
    fill: "#fff"
  })));
}
export default SvgTimelineWaiting;